import React, { Component } from 'react';
import HomeDesktop from '../components/home-components/homedesktop';
import HomeMobile from '../components/home-components/homemobile';
import { bindActionCreators } from 'redux';
import { app } from '../index';
import { connect } from 'react-redux';
import { getpath } from '../actions/get-path';
import { getAction } from '../actions/get-action';
import moment from 'moment';
import isMobile from 'ismobilejs';
import { modalhandler } from '../actions/modal-handler';
class Home extends Component {
  constructor() {
    super();
    this.state = {
      weekhours: null,
      absences: [],
      motd: null,
      messages: null,
      alerts: null,
      msgtab: null
    };
  }
  realtimeabsent() {
    let today = moment().format('YYYY-MM-DD');
    app.service('expectedabsence')
      .find({
        query: {
          datereturn: { $gt: today }
        }
      })
      .then(response => {
        console.log('absences error', response);

        this.setState({ absences: response });
      }).catch(err => 
        console.log('absences error', err));
  }
  genweekhours() {
    let Thiswedate = moment()
      .endOf('isoWeek')
      .format('YYYY-MM-DD');
    if (this.props.myinfo) {
      return app
        .service('dailylaborentries')
        .find({
          query: {
            empnumber: this.props.myinfo.empnumber,
            wedate: Thiswedate
          }
        })
        .then(results => {
          let weekhours = results.reduce((a, b) => a + parseFloat(b.hours), 0);
          this.setState({ weekhours: weekhours });
        });
    }
  }
  genmessages() {
    app
      .service('messages')
      .find({
        query: {
          toemp: this.props.myinfo.empnumber
        }
      })
      .then(response => {
        let newmessages = [];
        let newalerts = [];
        response.map(msg => {
          if (msg.importance === 'M') {
            newmessages = newmessages.concat(msg);
          } else if (msg.importance === 'A') {
            newalerts = newalerts.concat(msg);
          }
        });
        this.setState({ messages: newmessages, alerts: newalerts });
      });
  }
  componentDidMount() {
    console.log('we are home')
    this.genweekhours();
    this.genmotd();
    this.props.getpath('Home', 'home');
    this.props.get('inventory');
    if (
      this.state.weekhours === null &&
      this.props.dates.length !== 0 &&
      this.props.myinfo !== null
    ) {
    }
    this.realtimeabsent();
  }

  componentWillUnmount() {
    // this.absentservice.unsubscribe();
    this.setState({ weekhours: null });
  }

  genmotd() {
    app
      .service('motd')
      .find({
        query: {
          $limit: 1,
          $sort: {
            createdAt: -1
          }
        }
      })
      .then(results => {
        console.log(results);
        this.setState({ motd: results[0] });
      });
  }
  patchnote(note) {
    let noteservice = app.service('edfemployees');
    console.log('note is ' + note);
    noteservice
      .patch(this.props.myinfo.empnumber, { notetoself: note })
      .catch(error => console.log(error));
  }

  handleapprove(id) {
    app.service('expectedabsence').patch(id, { approval: true });
  }

  genHome() {
    if ((!this.state.messages || !this.state.alerts) && this.props.myinfo) {
      this.genmessages();
    }
    var mobileuser = isMobile.any;
    console.log('employees', this.props.employees, 'wods', this.props.wods, 'myinfo', this.props.myinfo, 'jobs', this.props.jobs)
    if (
      this.props.employees &&
      this.props.wods &&
      this.props.myinfo &&
      this.props.jobs
    ) {
      if (mobileuser) {
        return (
          <HomeMobile
            addabsence={abs => app.service('expectedabsence').create(abs)}
            motd={this.state.motd}
            absences={this.state.absences}
            jobs={this.props.jobs}
            time={this.props.time}
            myinfo={this.props.myinfo}
            patchnote={note => this.patchnote(note)}
            weekhours={this.state.weekhours}
            motd={this.state.motd}
            messages={this.state.message}
            alerts={this.state.alerts}
            handleapprove={id => this.handleapprove(id)}
          />
        );
      } else {
        return (
          <HomeDesktop
            addabsence={abs => app.service('expectedabsence').create(abs).then(() => this.realtimeabsent())}
            employees={this.props.employees}
            absences={this.state.absences}
            jobs={this.props.jobs}
            wods={this.props.wods}
            time={this.props.time}
            messagetab={tab => this.setState({ msgtab: tab })}
            messages={this.state.messages}
            alerts={this.state.alerts}
            myinfo={this.props.myinfo}
            patchnote={note => this.patchnote(note)}
            weekhours={this.state.weekhours}
            motd={this.state.motd}
            deleteabsence={id => app.service('expectedabsence').remove(id).then(() => this.realtimeabsent())}
            reloadmotd={() => this.genmotd()}
            updateabsence={abs =>{
              console.log("Updating Absence", abs)
              app
                .service('expectedabsence')
                .update(abs.id, abs)
                .then(response => this.realtimeabsent())}
            }
            handlemodal={modal => this.props.handlemodal(modal)}
            showabsencemodal={this.props.modal === 'absence'}
            modal={this.props.modal}
            modalstatus={this.props.modal}
            handleapprove={id => this.handleapprove(id)}
          />
        );
      }
    } else {
      this.props.handlemodal('loading');

      return <div />;
    }
  }

  render() {
    return <div className="Home">{this.genHome()}</div>;
  }
}
function mapStateToProps(state) {
  return {
    modal: state.modal,
    wods: state.workorders.derivitives,
    jobs: state.myinfo.myassignments,
    dates: state.dates.thisweek,
    myinfo: state.myinfo.employeeinfo,
    employees: state.employees.employees
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handlemodal: modalhandler,
      getpath: getpath,
      get: getAction
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js